export { default } from './Impact';
